// @mui
import { useSettingsContext } from 'src/components/settings';
import { useState, useCallback } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

// components
import Iconify from 'src/components/iconify';
import { hideScroll } from 'src/theme/css';
import WebsiteHomePage from './home-pages/website-home-page';
import Solution from './solution-pages/solution';
import { Button, Menu, MenuItem } from '@mui/material';
import Challenge from './solution-pages/by-challenge/challenge';
import Sector from './solution-pages/by-sector/sector';
import Role from './solution-pages/by-role/role';
import Contractor from './solution-pages/by-contractor/contractor';
import ProductTabMenu from './product-pages/product-main-page/product-tab-menu';
import Construction from './product-pages/construction-page/construction';
import ProjectManagement from './product-pages/project-management-page/project-management';
import FieldManagement from './product-pages/field-management/field-management';
import ResourceManagement from './product-pages/resource-management/resource-management';
import TimeManagement from './product-pages/time-management/time-management';
import SafetyChecklist from './product-pages/safety-checklist/safety-checklist';
import DailyCheckList from './product-pages/daily-check-list/daily-check-list';
import CommunicationManagement from './product-pages/communication-management/communication-management';
import SchedulePerformace from './product-pages/schdule-performace/schedule-performace';
import CostPerformace from './product-pages/cost-performace/cost-performace';
import CloseOut from './product-pages/close-out/close-out';
import DocumentControl from './product-pages/document-control/document-control';
import FinancialManagement from './product-pages/financial-management/financial-management';
import ReportAnalytics from './product-pages/report-analytics/report-analytics';
import TechnologyProductIntegration from './product-pages/technology-product-integration/technology-product-integration';
import UserManagement from './product-pages/user-management/user-management';
import PreConstruction from './product-pages/pre-construction/pre-construction';
import PostConstruction from './product-pages/post-construction/post-construction';
import SoftwareDevelopment from './product-pages/software-development/software-development';
import OfficeManagement from './product-pages/office-management/office-management';

// ----------------------------------------------------------------------

const TABS = [
  {
    value: 'Home Page',
    label: 'Home Page',
    icon: <Iconify icon="solar:home-bold" width={24} />,
  },
  {
    value: 'Solutions',
    label: 'Solutions',
    icon: <Iconify icon="ant-design:solution-outlined" width={24} />,
    menuItems: ['Solutions', 'By Challenge', 'By Sector', 'By Role', 'By Contractor'],
  },
  {
    value: 'Products',
    label: 'Products',
    icon: <Iconify icon="solar:box-bold" width={24} />,
    menuItems: ['Products', 'Construction', 'Project Management', 'Field Management', 'Resource Management', 'Time Management', 'Safety Checklist', 'Daily Checklist', 'Communication Management', 'Schedule Performance', 'Cost Performance', 'Close Out', 'Document Control', 'Financial Management', 'Report Analytics', 'Tech & Product Integration', 'User Management', 'Office Management', 'Pre Construction', 'Post Construction', 'Software Development'],
  },
  {
    value: 'Packages',
    label: 'Packages',
    icon: <Iconify icon="solar:document-bold" width={24} />,
  },
  {
    value: 'Resources',
    label: 'Resources',
    icon: <Iconify icon="solar:document-bold" width={24} />,
  },
];

export default function PagesMainTab() {
  const settings = useSettingsContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [currentTab, setCurrentTab] = useState('Home Page');
  const [avtiveMenu, setAvtiveMenu] = useState(null);

  const handleChangeTab = useCallback((event, newValue) => {
    const activeTab = TABS.find(tab => tab.value === newValue);
    setCurrentTab(newValue);
    // Close any open menu when changing tabs
    if (activeTab.menuItems && activeTab.menuItems.length > 0) {
      setAvtiveMenu(activeTab.menuItems[0]); // Set the first menu item as active
    } else {
      setAvtiveMenu(null); // No menu items, reset active menu
    }
    setAnchorEl(null);
  }, []);

  const handleMenuOpen = useCallback((event, tabValue) => {
    event.stopPropagation(); // Prevent tab change when opening menu
    console.log('working open menu for:', tabValue);
    setAnchorEl(event.currentTarget);
    setActiveMenu(tabValue);
  }, []);

  const handleMenuClose = useCallback(() => {
    console.log('working close menu');
    setAnchorEl(null);
    setActiveMenu(null);
  }, []);

  const handleMenuItemClick = useCallback((option, tabValue) => {
    console.log('working menu item click:', option, 'for tab:', tabValue);
    const activeTab = TABS.find(tab => tab.menuItems && tab.menuItems.includes(option));
    setCurrentTab(activeTab.value);
    setAvtiveMenu(option);
    handleMenuClose();
    // Add your menu item logic here
  }, [handleMenuClose]);
  console.log(avtiveMenu, "sdsadhgsadh")
  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <Card>
        <Box
          sx={{
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              width: '100%',
              overflowX: 'auto',
              ...hideScroll.x,
            }}
          >
            <Tabs
              value={currentTab}
              onChange={handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                px: 2.5,
                boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
              }}
            >
              {TABS.map((tab) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <span>{tab.label}</span>
                      {tab?.menuItems?.length > 0 && <Button
                        size="small"
                        onClick={(e) => handleMenuOpen(e, tab.value)}
                        sx={{ minWidth: 'auto', p: 0.5 }}
                      >
                        <Iconify icon="eva:more-vertical-fill" width={16} />
                      </Button>}
                    </Box>
                  }
                  icon={tab.icon}
                  iconPosition="start"
                />
              ))}
            </Tabs>
          </Box>

          {/* Single Menu component outside of tabs */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            slotProps={{
              paper: {
                sx: {
                  ...(activeMenu === 'Products' && {
                    width: 650,
                    maxHeight: 500,
                    '& .MuiList-root': {
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr',
                      gap: 0,
                      padding: 1,
                    },
                  }),
                },
              },
            }}
          >
            {activeMenu && TABS.find(tab => tab.value === activeMenu)?.menuItems.map((option) => (
              <MenuItem
                key={option}
                onClick={() => handleMenuItemClick(option, activeMenu)}
                sx={{
                  ...(activeMenu === 'Products' && {
                    minHeight: 40,
                    fontSize: '0.875rem',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }),
                }}
              >
                {option}
              </MenuItem>
            ))}
          </Menu>
        </Box>

        {currentTab === 'Home Page' && (
          <Box sx={{ p: 3 }}>
            <WebsiteHomePage />
          </Box>
        )}

        {currentTab === 'Solutions' && (
          <Box sx={{ p: 3 }}>
            {(avtiveMenu === 'Solutions') && (
              <Solution />
            )}

            {avtiveMenu === 'By Challenge' && (
              <Challenge />
            )}

            {avtiveMenu === 'By Sector' && (
              <Sector />
            )}

            {avtiveMenu === 'By Role' && (
              <Role />
            )}

            {avtiveMenu === 'By Contractor' && (
              <Contractor />
            )}
          </Box>
        )}

        {currentTab === 'Products' && (
          <Box sx={{ p: 3 }}>

            {(avtiveMenu === 'Products') && (
              <ProductTabMenu />
            )}

            {avtiveMenu === 'Construction' && (
              <Construction />
            )}

            {avtiveMenu === 'Project Management' && (
              <ProjectManagement />
            )}

            {avtiveMenu === 'Field Management' && (
              <FieldManagement />
            )}

            {avtiveMenu === 'Resource Management' && (
              <ResourceManagement />
            )}

            {avtiveMenu === 'Time Management' && (
              <TimeManagement />
            )}

            {avtiveMenu === 'Safety Checklist' && (
              <SafetyChecklist />
            )}

            {avtiveMenu === 'Daily Checklist' && (
              <DailyCheckList />
            )}

            {avtiveMenu === 'Communication Management' && (
              <CommunicationManagement />
            )}

            {avtiveMenu === 'Schedule Performance' && (
              <SchedulePerformace />
            )}

            {avtiveMenu === 'Cost Performance' && (
              <CostPerformace />
            )}

            {avtiveMenu === 'Close Out' && (
              <CloseOut />
            )}

            {avtiveMenu === 'Document Control' && (
              <DocumentControl />
            )}

            {avtiveMenu === 'Financial Management' && (
              <FinancialManagement />
            )}

            {avtiveMenu === 'Report Analytics' && (
              <ReportAnalytics />
            )}

            {avtiveMenu === 'Tech & Product Integration' && (
              <TechnologyProductIntegration />
            )}

            {avtiveMenu === 'User Management' && (
              <UserManagement />
            )}

            {avtiveMenu === 'Office Management' && (
              <OfficeManagement />
            )}

            {avtiveMenu === 'Pre Construction' && (
              <PreConstruction />
            )}

            {avtiveMenu === 'Post Construction' && (
              <PostConstruction />
            )}

            {avtiveMenu === 'Software Development' && (
              <SoftwareDevelopment />
            )}

          </Box>
        )}

        {currentTab === 'Packages' && (
          <Box sx={{ p: 3 }}>
            <Typography variant="h6" paragraph>
              Packages Content
            </Typography>
            <Typography>
              Manage your website's Packages content here.
            </Typography>
          </Box>
        )}

        {currentTab === 'Resources' && (
          <Box sx={{ p: 3 }}>
            <Typography variant="h6" paragraph>
              Resources Content
            </Typography>
            <Typography>
              Manage your website's Resources content here.
            </Typography>
          </Box>
        )}
      </Card>
    </Container>
  );
}
